export enum SourceOfRecommendation {
  MANUAL_ADDITION = 'MAN',
  ALWAYS_INSPECT = 'REC',
  DENSITY = 'DEN',
  PROCESS_AS_DENSITY = 'DEN',
  ZIP_TO_ZIP = 'ZIP',
  ELS = 'ELS'
}
